module.exports = __webpack_public_path__ + "img/hb_bottom.5c147e77.png";